import { IStatusStep } from '@features/cart/typescript';

export const STATUS_DONE = 'done';
export const STATUS_CURRENT = 'current';
export const STATUS_TODO = 'toDo';
export const STATUS_ALERT = 'alert';

export const ORDER_STATUS_STEP_CART: IStatusStep = {
  name: 'cart.cart',
  pathname: '/cart',
  alert: false,
  stepID: 1,
};
export const ORDER_STATUS_STEP_CHECKOUT: IStatusStep = {
  name: 'cart.deliveryAndPayment',
  pathname: '/checkout/order',
  alert: false,
  stepID: 2,
};
export const ORDER_STATUS_STEP_SUMMARY: IStatusStep = {
  name: 'cart.summary',
  pathname: '/checkout/summary',
  alert: false,
  stepID: 3,
};
export const ORDER_STATUS_STEP_READY: IStatusStep = {
  name: 'cart.ready',
  pathname: '/orderConfirmation',
  alert: false,
  stepID: 4,
};

export const REPAYMENT_STATUS_STEP_DETAILS: IStatusStep = {
  name: 'repayment.details',
  pathname: '',
  alert: false,
  stepID: 1,
};
export const REPAYMENT_STATUS_STEP_CHOOSE_PAYMENT: IStatusStep = {
  name: 'repayment.choosePayment',
  pathname: '',
  alert: true,
  stepID: 2,
};
export const REPAYMENT_STATUS_STEP_READY: IStatusStep = {
  name: 'repayment.ready',
  pathname: '',
  alert: false,
  stepID: 3,
};
export const STATUS_STEP_ORDER = {
  order: [ORDER_STATUS_STEP_CART, ORDER_STATUS_STEP_CHECKOUT, ORDER_STATUS_STEP_SUMMARY, ORDER_STATUS_STEP_READY],
  repayment: [REPAYMENT_STATUS_STEP_DETAILS, REPAYMENT_STATUS_STEP_CHOOSE_PAYMENT, REPAYMENT_STATUS_STEP_READY],
};

export const BUSINESS_DAYS_MATRIX = {
  pl: [1, 2, 3, 4, 5],
  mx: [0, 1, 2, 3, 4, 5],
  eur: [1, 2, 3, 4, 5],
};

export const BRINGING_SERVICE_ID = 'bbbeda72-a81a-44c1-9c9b-a21e3a6e6da2';
export const ASSEMBLY_SERVICE_ID = '91ffc15c-e9b6-4af4-948c-ad5207af1bb2';

export const BRINGING_SERVICE_NAME = 'service.bringService';
export const ASSEMBLY_SERVICE_NAME = 'service.assembly';
export const EXPRESS_SERVICE_NAME = 'service.expressDelivery';
export const EXPRESS_SERVICE_TYPE = 'express_delivery';

export const ASSEMBLY_SERVICE_VAT_8_ID = '83e4a937-eaad-45f2-8af5-a6a109db7c07';
export const ASSEMBLY_SERVICE_VAT_23_ID = '91ffc15c-e9b6-4af4-948c-ad5207af1bb2';

export const STOR_CATEGORY_ID = 2420437;

/** Coupon code that requires an extra checkout consent (Back to School). Swap when the real promo code is ready. */
export const PROMO_CONSENT_COUPON_CODE = 'SCHOOL';

export const CLOSET_TYPE_ID = 21742;
export const CLOSET_SUBTYPE_ID = 2433261;
export const CLOSET_SUBTYPE_MASKING_ID = 2532054;
export const CLOSET_SUBTYPE_SIDE_ID = 2532055;
